var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeatmapChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heatmap__Property 1=Heatmap",
    className: "heatmap__Property heatmap__1=Heatmap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heatmap__Vector",
    className: "heatmap__Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#919EAB",
    fillOpacity: 0.16,
    d: "M2.669 3.083h19.013c.12 0 .216.096.216.216V20.7c0 .12-.097.216-.216.216H2.669a.216.216 0 0 1-.216-.216V3.3c0-.12.097-.216.216-.216Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596773",
    d: "M15.687 20.648h5.94v-5.504h-5.94v5.504Zm-6.481 0h5.941v-5.504H9.206v5.504Zm-6.483 0h5.942v-5.504H2.723v5.504Zm12.964-6.044h5.94V9.1h-5.94v5.503Zm-6.481 0h5.941V9.1H9.206v5.503Zm-6.483 0h5.942V9.1H2.723v5.503ZM15.687 8.56h5.94V3.353h-5.94V8.56Zm-6.481 0h5.941V3.353H9.206V8.56Zm-6.483 0h5.942V3.353H2.723V8.56ZM22.168 20.7a.487.487 0 0 1-.486.487H2.669a.487.487 0 0 1-.477-.388l-.01-.099V3.3c0-.269.219-.486.487-.486h19.013c.268 0 .486.217.486.486v17.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0054EC",
    fillOpacity: 0.16,
    d: "M2.438 8.833V3.299c0-.12.097-.216.216-.216h6.287v5.75H2.438Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#011E60",
    d: "M9.21 2.813v6.29H2.169V3.3c0-.269.218-.486.486-.486h6.557Zm-6.502 5.75h5.963v-5.21H2.708v5.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0054EC",
    fillOpacity: 0.16,
    d: "M21.898 8.833V3.299a.216.216 0 0 0-.216-.216h-6.287v5.75h6.503Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#011E60",
    d: "M15.125 2.813v6.29h7.043V3.3a.487.487 0 0 0-.486-.486h-6.557Zm6.503 5.75h-5.963v-5.21h5.963v5.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0054EC",
    fillOpacity: 0.16,
    d: "M15.395 20.919v-6.05H8.941v6.05h6.454Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#011E60",
    d: "M8.67 14.599v6.59h6.995v-6.59H8.671Zm6.455 6.05H9.211v-5.51h5.914v5.51Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatmapChart);
export default __webpack_public_path__ + "static/media/heatmap_chart.717cec1a7fd6f329b0c6b633670d5844.svg";
export { ForwardRef as ReactComponent };